import getUserLanguage from 'src/utils/getUserLanguage'
import { APPOINTMENT_SOURCE } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPrices/constants'

type RedirectToServiceAppointmentOptions = {
  lpuId: number
  serviceId: number
  byReferral?: boolean
  slot?: string
}

/**
 * Редирект на форму записи на услугу клиники.
 *
 * URL совпадает с `AppointmentModules.redirectToNewAppointmentClinic`:
 * LocationParser из www на SSR тянет `window` и CASE_NOUN.
 */
export default function redirectToServiceAppointment({
  lpuId,
  serviceId,
  byReferral,
  slot,
}: RedirectToServiceAppointmentOptions) {
  if (typeof window === 'undefined') {
    return
  }

  const userLanguage = getUserLanguage()
  let { origin } = window.location

  if (
    window.LANGUAGE_DATA
    && userLanguage !== window.LANGUAGE_DATA.defaultLanguageIso
  ) {
    origin += `/${userLanguage}`
  }

  const params = new URLSearchParams({
    lpu: String(lpuId),
    source: APPOINTMENT_SOURCE,
    service: String(serviceId),
  })

  if (byReferral) {
    params.set('by_referral', 'true')
  }

  if (slot) {
    params.set('slot', slot)
  }

  window.location.href = `${origin}/appointment/uslugi/new/?${params.toString()}`
}
